<template>
  <p class="caption ma-0" v-if="beerDetails">
    {{ beerDetails.stil }} ({{ beerDetails.alkoholhalt }}%).
  </p>
</template>
<script>
export default {
  props: {
    systembolagetNr: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      beerDetails: null
    }
  },
  mounted () {
    // Items have already been loaded'
    if (this.beerDetails) {
      return
    }

    // Lazily load input items
    fetch('https://api.3ol3.nu/api/beverages/beers/' + this.systembolagetNr)
      .then(res => res.json())
      .then(res => {
        let result = null

        if (res.status) {
          result = res[0]
        }

        this.beerDetails = result
      })
  }
}
</script>
